// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1PAWv","buttons":"PendingPaymentAlert_buttons__3GAkZ"};